import React, { forwardRef } from 'react';
import DateInput from '~components/DateInput';
import Input from '~components/Input';
import { Calendar } from 'styled-icons/boxicons-regular/Calendar';
import { parse, format } from 'date-fns';

type Props<T extends string> = {
  name: T;
  value: string;
  onChange: (value: string) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  hasError?: boolean;
  dateFormat?: string;
  placeholderText?: string;
};

// to avoid datepicker error
const DatepickerInput = forwardRef(Input);

const DateInputWithCalendarIcon = <T extends string>({
  value,
  onChange,
  hasError,
  onBlur,
  placeholderText,
  dateFormat = 'dd.MM.yy',
}: Props<T>) => (
  <DateInput
    selected={value ? parse(value, dateFormat, new Date()) : null}
    placeholderText={placeholderText}
    onChange={(value: Date) => onChange(format(value, dateFormat))}
    onBlur={onBlur}
    dateFormat={dateFormat}
    customInput={
      <DatepickerInput
        name={'name'}
        iconElement={<Calendar size='100%' color='#78c810' />}
        hasError={hasError}
        viewStyle='white'
        value=''
        onChange={() => {}}
        onBlur={() => {}}
      />
    }
  />
);

export default DateInputWithCalendarIcon;
